import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "../site/Reveal";

const CARDS = [
  { to: "/remplacement-pare-brise-haguenau", t: "Remplacement de pare-brise", d: "Changement de pare-brise sur voitures, utilitaires et autres véhicules. Calibration caméra si nécessaire.", cta: "Demander un devis", img: "/images/vitrage.webp", alt: "Remplacement de pare-brise à Haguenau", cls: "lg:col-span-8 lg:row-span-2", big: true },
  { to: "/reparation-impact-pare-brise-haguenau", t: "Réparation d'impact", d: "Lorsque c'est techniquement possible, on répare plutôt que de remplacer.", cta: "Faire contrôler mon impact", cls: "lg:col-span-4", tone: "yellow" },
  { to: "/vitrage-automobile-haguenau", t: "Vitrage automobile", d: "Vitres latérales, lunette arrière et vitrages de différents véhicules.", cta: "Voir le vitrage", cls: "lg:col-span-4", tone: "navy" },
  { to: "/calibration-camera-adas-haguenau", t: "Calibration caméra / ADAS", d: "Outils professionnels de calibration pour vos aides à la conduite.", cta: "Comprendre l'ADAS", img: "/images/camera-adas.webp", alt: "Caméra ADAS installée derrière le pare-brise, calibration à Haguenau", cls: "lg:col-span-4" },
  { to: "/renovation-optiques-phares-haguenau", t: "Rénovation d'optiques", d: "Phares jaunis, ternis ou oxydés : retrouvez de la transparence.", cta: "Rénover mes optiques", img: "/images/optique.webp", alt: "Rénovation de phares à Haguenau", cls: "lg:col-span-4" },
  { to: "/pare-brise-domicile-haguenau", t: "Intervention à domicile", d: "Chez vous ou au travail, dans les secteurs réellement desservis.", cta: "Vérifier mon adresse", cls: "sm:col-span-12 lg:col-span-4", tone: "blue" },
];

const TONES = { yellow: "bg-ag-yellow text-ag-ink", navy: "bg-ag-navy text-white", blue: "bg-ag-blue text-white" };

function Card({ c, i }) {
  const photo = Boolean(c.img);
  const tone = photo ? "text-white" : TONES[c.tone];
  return (
    <Reveal delay={i * 0.06} className={`col-span-12 sm:col-span-6 ${c.cls} ${c.big ? "sm:col-span-12" : ""}`}>
      <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} className="h-full">
        <Link to={c.to} className={`group relative flex h-full min-h-[280px] flex-col justify-end overflow-hidden rounded-[1.75rem] p-7 ${c.big ? "lg:min-h-[584px] sm:p-10" : ""} ${tone} ${photo ? "bg-ag-ink" : ""}`} data-testid={`service-card-${c.to.slice(1)}`}>
          {photo && (
            <>
              <img src={c.img} alt={c.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-[1.2s] ease-out group-hover:scale-105" width="1400" height="930" />
              <div className="absolute inset-0 bg-gradient-to-t from-ag-ink via-ag-ink/50 to-transparent" />
            </>
          )}
          <span className={`absolute right-6 top-6 grid h-11 w-11 place-items-center rounded-full transition-transform duration-500 group-hover:rotate-45 ${photo || c.tone !== "yellow" ? "bg-white/15 ring-1 ring-white/30" : "bg-ag-ink/10"}`}><ArrowUpRight className="h-5 w-5" /></span>
          <span className="relative font-mono text-xs opacity-80">0{i + 1}</span>
          <h3 className={`relative mt-2 font-display font-extrabold leading-[1.02] tracking-tight ${c.big ? "text-3xl sm:text-5xl" : "text-2xl"}`}>{c.t}</h3>
          <p className={`relative mt-3 max-w-md text-sm leading-relaxed ${photo ? "text-slate-200" : "opacity-90"}`}>{c.d}</p>
          <span className="relative mt-5 inline-flex items-center gap-2 text-sm font-bold underline decoration-2 underline-offset-4">{c.cta}</span>
        </Link>
      </motion.div>
    </Reveal>
  );
}

export function ServicesBento() {
  return (
    <section id="services" className="px-5 py-24 lg:px-8" data-testid="services-section">
      <div className="mx-auto max-w-[1320px]">
        <div className="mb-12 grid gap-6 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="eyebrow">Nos services à Haguenau</p>
            <h2 className="mt-3 font-display text-4xl font-extrabold leading-[1] tracking-tight text-ag-ink sm:text-5xl">Pare-brise, vitrage et éclairage tous véhicules.</h2>
          </Reveal>
          <Reveal delay={0.1} className="text-slate-600 lg:col-span-4 lg:col-start-9">
            Du simple impact à la calibration ADAS, en passant par la rénovation de phares : une seule adresse, au 101A Route de Marienthal.
          </Reveal>
        </div>
        <div className="grid grid-cols-12 gap-4 lg:auto-rows-[284px]">
          {CARDS.map((c, i) => <Card key={c.to} c={c} i={i} />)}
        </div>
      </div>
    </section>
  );
}
